import React, { memo } from 'react'
import { Path, Circle as _Circle, Rect } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 75 74"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Rect x={0.998} width={74.002} height={74} rx={37} fill="#529FEB" />
      <Path
        d="M54.23 26.294c-.534.237-1.084.437-1.645.6a7.27 7.27 0 0 0 1.48-2.603.548.548 0 0 0-.802-.64 12.941 12.941 0 0 1-3.825 1.513 7.335 7.335 0 0 0-5.11-2.083c-4.024 0-7.298 3.275-7.298 7.3 0 .316.02.631.06.942a18.686 18.686 0 0 1-12.826-6.804.547.547 0 0 0-.899.07 7.294 7.294 0 0 0-.988 3.67c0 1.76.628 3.428 1.737 4.732a6.182 6.182 0 0 1-.977-.437.548.548 0 0 0-.815.467v.098a7.325 7.325 0 0 0 3.573 6.277 6.32 6.32 0 0 1-.556-.081.548.548 0 0 0-.625.706 7.296 7.296 0 0 0 5.347 4.892 12.912 12.912 0 0 1-6.902 1.97c-.517 0-1.037-.03-1.546-.09a.549.549 0 0 0-.36 1.006 19.683 19.683 0 0 0 10.643 3.12c7.431 0 12.08-3.505 14.671-6.444 3.231-3.666 5.084-8.518 5.084-13.312 0-.2-.003-.402-.009-.604a14.187 14.187 0 0 0 3.265-3.459.548.548 0 0 0-.677-.806Z"
        fill="#fff"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconTwitterCircle'

export const IconTwitterCircle = memo<IconProps>(themed(Icon))
